import { InvoiceThird } from './invoice-third.model';

export class InvoicePlace {
  costCenter: string;
  third: InvoiceThird | null;

  constructor(values= {}) {
    Object.assign(this, values);

    if (this.third) {
      this.third = new InvoiceThird(this.third);
    }
  }
}
